export default __webpack_public_path__ + "static/media/ranjith.e07afbfc.jpeg";